var styles = require('./visuallyhidden-hashed.scss');

/**
 * Makes content visually hidden unless condition is met
 * ('visibility: hidden' rather than 'display: none' to avoid jumps)
 */

export default [function () {
    return {
        restrict: 'A',
        link: function link($scope, $element, $attr) {
            $scope.$watch($attr.gwVisuallyhiddenUnless, function (value) {
                $element.toggleClass(styles['gw-visuallyhidden'], !value);
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/loading/VisuallyHiddenDirective.js
// module id = 1991
// module chunks = 0